
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConverterDcdcOff as ObiConverterDcdcOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-converter-dcdc-off.js';
 
 
 

 
 export const ObiConverterDcdcOff = createComponent({
   react: React,
   tagName: 'obi-converter-dcdc-off',
   elementClass: ObiConverterDcdcOffElement,
   events: {
     
   }
  });
 
 